import { CheckCircleOutlined, CloseCircleOutlined } from '@ant-design/icons';
import { ProgressChecklistItem } from './types';
import {
    BarRow,
    CountLabel,
    ItemIcon,
    ItemLabel,
    ItemMessage,
    ItemRow,
    ItemsList,
    ItemTextWrapper,
    Segment,
    SegmentedBar,
    Wrapper,
} from './styles';

export interface ProgressChecklistProps {
    items: ProgressChecklistItem[];
    sorted?: boolean;
}

const ProgressChecklist = ({ items, sorted }: ProgressChecklistProps) => {
    const passedCount = items.filter((item) => item.passed).length;
    const sortedItems = items.slice().sort((a, b) => Number(b.passed) - Number(a.passed));
    const itemsList = sorted ? sortedItems : items;

    return (
        <Wrapper>
            <BarRow>
                <SegmentedBar>
                    {sortedItems.map((item) => (
                        <Segment key={item.key} $passed={item.passed} />
                    ))}
                </SegmentedBar>
                <CountLabel>
                    ({passedCount}/{items.length})
                </CountLabel>
            </BarRow>
            <ItemsList>
                {itemsList.map((item) => (
                    <ItemRow key={item.key}>
                        <ItemIcon $passed={item.passed}>
                            {item.passed ? <CheckCircleOutlined /> : <CloseCircleOutlined />}
                        </ItemIcon>
                        <ItemTextWrapper>
                            <ItemLabel $passed={item.passed}>{item.label}</ItemLabel>
                            <ItemMessage>{item.errorMessage || item.group}</ItemMessage>
                        </ItemTextWrapper>
                    </ItemRow>
                ))}
            </ItemsList>
        </Wrapper>
    );
};

export default ProgressChecklist;
